
module.exports = class ToolchestCreateOrDeleteButton extends React.Component
  displayName: 'ToolchestCreateOrDeleteButton'

  constructor: (props) ->
      super(props)
      # Expects: @props.
      # my_accepted_roles
      @state = { }

  render: =>

      if @props.tool_selected is 'create_delete_tools'
          card_className = 'card light_green'
      else
          card_className = 'card light_gray'

      <div className={card_className}>
        <div className="card-body">
            <h2 className="card-title">
                <button className='btn btn-primary'
                        onClick={ @props.onClick.bind(this, {tools: 'create_delete_tools', show_this: 'create_delete_tools'}) }>
                    finishing up
                </button>
            </h2>
            <p className="card-text">
                Set up next year's conference with a click! (Or delete this one).
            </p>
        </div>
      </div>
